var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('user-accessible-rooms',{attrs:{"rooms":_vm.rooms}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }